import styled from 'styled-components';
import {
    Card,
    Typography,
    IconButton,
} from "@mui/material";

export const BuyLicenseCardContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    display: grid;
    grid-template-columns: auto;
    gap: 30px;
    box-shadow: none !important;
    padding: 10px 0px;
`;

export const OtherLicenseDetails = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: solid 1px;
    border-radius: 4px !important;
    box-shadow: none !important;
    grid-column: span 2;
    width: -webkit-fill-available;
    display: grid;
    grid-template-columns: 3fr 1.5fr;
`;

export const OtherLicenseDetailsFormContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    width: -webkit-fill-available;
    padding: 20px;

    .otherDetailsFormContainer {
        display: grid;
        // grid-template-columns: 1fr 1fr 1fr;
        grid-template-columns: auto auto auto;
        column-gap: 20px;
        row-gap: 10px;
        margin: 0px 0px 20px 0px;

        .span3Item {
            grid-column: span 3;
        }

        .userCapacitySlider {
            width: 95%;
            place-self: center;
            margin: 10px 0px 0px 0px;
        }

        .otherDetailsHeaderTitleContainer {
            .otherDetailsHeaderTitle {
                font-size: 1.3125rem !important;
                font-weight: 600 !important;
            }

            .otherDetailsSubHeaderTitle {
                font-size: 0.825rem !important;
                font-weight: 400 !important;
            }
        }

        &:first-of-type {
            margin: 0px 0px 40px 0px;
        }
    }
`;

export const ModuleItemContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: 1px solid;
    border-radius: 4px !important;
    box-shadow: none !important;
    width: -webkit-fill-available;
    padding: 15px 10px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .checkBoxContainer {
        .formControlContainer {
            .formCheckboxContainer {
                .checkboxSideLabel {
                    font-size: 16px;
                    font-weight: 600;
                    color: ${(props) => props.$darkMode ? '#ced4da' : '#495057'} !important;
                    word-break: break-all;
                }
            }
        }

    }

    .moduleItemPrice {
        font-size: 0.825rem !important;
        font-weight: 600 !important;
        color: #878a99 !important;
        margin: 0px 0px 0px 29px;
    }

    .clickerDiv {
        background: transparent;
        position: absolute;
        left: 0;
        top: 0;
        width: -webkit-fill-available;
        height: -webkit-fill-available;
        cursor: pointer;
    }
`;

export const StorageItemContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: 1px solid;
    border-radius: 4px !important;
    box-shadow: none !important;
    width: -webkit-fill-available;
    padding: 15px 10px;
    position: relative;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .radioFieldContainer {
        .MuiFormControl-root {
            .MuiFormGroup-root.MuiRadioGroup-root {
                .MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementEnd {
                    margin: 0px !important;

                    .MuiButtonBase-root.MuiRadio-root.MuiRadio-colorPrimary.PrivateSwitchBase-root.MuiRadio-root.MuiRadio-colorPrimary.MuiRadio-root.MuiRadio-colorPrimary {
                        padding: 0px;
                        margin: 0px 10px 0px 0px;
                    }

                    .MuiTypography-root.MuiTypography-body1.MuiFormControlLabel-label {
                        .radioButtonSideLabelContainer {
                            // display: flex;
                            align-items: center;

                            .storageGBText {
                                font-size: 16px;
                                font-weight: 600;
                                color: ${(props) => props.$darkMode ? '#ced4da' : '#495057'} !important;
                            }

                            .storagePriceText {
                                // font-size: 12px;
                                font-size: 11px;
                                font-weight: 600;
                                color: ${(props) => props.$darkMode ? '#ced4da' : '#495057'} !important;
                                // margin: 0px 0px 0px 5px;
                                margin: 0px;
                            }
                        }
                    }
                }
            }
        }
    }

    .storageItemDescription {
        font-size: 11px !important;
        font-weight: 600 !important;
        color: #878a99 !important;
        margin: 0px 0px 0px 29px;
    }

    .clickerDiv {
        background: transparent;
        position: absolute;
        left: 0;
        top: 0;
        width: -webkit-fill-available;
        height: -webkit-fill-available;
        cursor: pointer;
    }
`;

export const EstimateContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: ${(props) => props.$darkMode ? '#222527' : '#def1fb'} !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    width: -webkit-fill-available;
    padding: 20px;
    place-content: center;

    .customSwitchContainer {
        place-self: center;

        .MuiFormControl-root {
            .switchFormContainer {
                .switchSideLabel {
                    font-size: 16px !important;
                    font-weight: 500;
                }
            }
        }
    }

    .divider {
        margin: 30px 0px;
    }

    .upToTextContainer {
        display: flex;
        // align-items: baseline;
        // align-items: center;
        justify-content: center;

        .userCapacityField {
            width: 120px;
            margin: 0px 10px;

            .MuiFormControl-root.MuiFormControl-marginNormal.MuiFormControl-fullWidth.MuiTextField-root {
                .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-sizeSmall {
                    background: ${(props) => props.$darkMode ? 'transparent' : '#fff'} !important;
                    height: 50px;
                    max-height: unset !important;

                    input[type="number"] {
                        -moz-appearance: textfield !important;
                    }

                    input[type="number"]::-webkit-outer-spin-button,
                    input[type="number"]::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }

                    input[type="number"] {
                        font-size: 20px;
                        font-weight: 600;
                        place-items: center;
                    }

                    .MuiOutlinedInput-notchedOutline {
                        // background: ${(props) => props.$darkMode ? 'transparent' : '#fff'} !important;
                    }
                }
            }
        }

        .upToText {
            font-size: 18px;
            font-weight: 600;
            margin: 12px 0px 0px 0px;
        }

        .empCount {
            font-size: 25px;
            font-weight: 600;
            margin: 0px 8px;
        }
    }

    .estimateTotalCostText {
        font-size: 16px;
        font-weight: 600;
        color: ${(props) => props.$darkMode ? '#ced4da' : '#495057'} !important;
        place-self: center;
    }

    .estimatedTotalCostContainer {
        display: flex;
        align-items: baseline;
        justify-content: center;

        .estimatedTotalCost {
            font-size: 1.75rem;
            font-weight: 700;
        }

        .monthlyText {
            font-size: 14px;
            font-weight: 600;
            color: ${(props) => props.$darkMode ? '#ced4da' : '#495057'} !important;
            margin: 0px 0px 0px 8px;
        }
    }

    .youSavedTextContainer {
        display: flex;
        align-items: baseline;
        justify-content: center;

        .youSavedText {
            font-size: 0.825rem;
            font-weight: 500;
            color: var(--textSuccessColor) !important;
        }

        .savedAmount {
            font-size: 0.825rem;
            font-weight: 600;
            color: var(--textSuccessColor) !important;
            margin: 0px 0px 0px 5px;
        }
    }

    .baseOnSelectedText {
        color: #878a99 !important;
        font-size: 0.825rem;
        font-weight: 500;
        justify-self: center;
        text-align: center;
        margin: 10px 0px 0px 0px;
    }
`;

export const FormContainer = styled(Card) <{ $darkMode?: boolean; }>`
    box-shadow: none !important;
    background: transparent !important;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    width: 65%;
    place-self: center;
    justify-items: center;
    overflow: unset !important;

    .buyLicenseHeaderContainer {
        grid-column: span 2;
    }

    .customDatePicker {
        width: -webkit-fill-available;

        .MuiStack-root {
            width: -webkit-fill-available;

            .MuiFormControl-root.MuiTextField-root,
            .MuiFormControl-root.MuiPickersTextField-root {
                width: -webkit-fill-available !important;
            }
        }
    }

    .span2Item {
        grid-column: span 2;
    }

    .checkoutBtn {
        width: -webkit-fill-available;
        grid-column: span 2;
    }
`;

export const AmountsContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    display: grid;
    grid-template-columns: 1fr;
    gap: 5px;
    box-shadow: none !important;
    overflow: unset !important;
    width: 100%;
    margin: 20px 0px;
    align-items: center;
    grid-column: span 2;

    .amountItems {
        font-size: 0.80rem;
        font-weight: 500;
        // margin: 10px 0px;
    }

    .rightItems {
        text-align: right;
        font-weight: 600;
    }

    .itemContainer {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 5px;
        padding: 2px 10px;
        align-items: center;
    }

    .grandTotalContainer {
        background: ${(props) => props.$darkMode ? '#372800' : '#fff5da'} !important;
        padding: 5px 10px;

        .grandTotalTextContainer {
            display: flex;
            align-items: center;

            .amountItems {
                font-size: 20px !important;
                font-weight: 600;
            }

            .afterRoundingText {
                font-size: 0.80rem !important;
                font-weight: 500;
                margin: 0px 0px 0px 5px;
            }
        }

        .rightItems {
            font-size: 20px !important;
            font-weight: 600;
            justify-self: end;
        }

        
    }

    .divider {
        margin: 0px 0px 10px 0px;
    }
`;

export const BuyErrorMessage = styled(Typography) <{ $darkMode?: boolean; }>`
    color: #d32f2f !important;
    font-weight: 400 !important;
    font-size: 0.75rem !important;
`;

export const ExclamationBtn = styled(IconButton)`
    width: 15px;
    height: 15px;
    padding: 0px !important;
    margin: 0px 0px 0px 10px !important;
    line-height: 1;
    z-index: 1;
    align-self: center;
`

export const BuyLicensePopperNotes = styled.div <{ $darkMode?: boolean; }>`
    padding: 10px 0px 10px 0px;

    .popperNoteTitle {
        font-size: 14px;
        font-weight: 600;
        padding: 0px 10px;
    }

    .popperNoteDivider {
        // background: #ced4da;
        margin: 5px 0px 10px 0px;
    }

    .popperNoteDescription {
        font-size: 14px;
        font-weight: 400;
        padding: 0px 10px;
    }

`